import { Directive, Input, OnInit, ElementRef, AfterViewInit, Renderer2, OnChanges, SimpleChanges, ChangeDetectorRef } from "@angular/core";
import { get } from "lodash";
import { UtilService } from "../services/util.service";

@Directive({
  selector: "[appAccessControl]",
  exportAs: "appAccessControl",
  standalone: true
})
export class AccessControlDirective implements AfterViewInit, OnChanges {
  @Input("moduleType") moduleType: string;
  @Input("pageType") pageType: string;
  @Input("permissionName") permissionName: string;
  @Input('elementValue') elementValue : any;
  @Input('additionalRowPermission') additionalRowPermission : string;
  @Input('conditionalOperator') conditionalOperator : string;
  @Input('conditionalValue') conditionalValue : string;
  @Input('rowKey') rowKey: string;    // e.g., 'no_of_versions'
  @Input('compareKey') compareKey: string; // e.g., 'count_of_versions'
  isDenied = false; 
  constructor(private elementRef: ElementRef, private util: UtilService, private renderer: Renderer2, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit() {
    this.elementRef.nativeElement.disabled = true;
    this.renderer.addClass(this.elementRef.nativeElement, 'disabled');
    this.checkAccess();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Re-evaluate access whenever inputs change
    if (changes['elementValue'] || changes['conditionalValue']) {
      setTimeout(() => {
        this.checkAccess();
      }, 0);
    }
  }

  checkAccess() {
    // TO DO : Local Storage will be removed
    const menuAccess = JSON.parse(this.util.decrypt(localStorage.getItem('menu_access')));
    /* Feature Level Permission Check */
    const featureAccess = this.util.getFeatureAccess(menuAccess, this.moduleType, this.pageType);
    let hasPermission = true;
    if(this.permissionName){
      hasPermission = featureAccess.includes(this.permissionName);
    }
    /* Data Level Permission Check */
    let dataLevelPermission = true;
    if (this.elementValue && this.rowKey && this.compareKey) {
      const leftValue = get(this.elementValue, this.rowKey, null);
      const rightValue = get(this.elementValue, this.compareKey, null);

      // Convert to numbers if numeric comparison
      const numLeft = Number(leftValue);
      const numRight = Number(rightValue);

      if (this.elementValue?.is_evaluation_criteria_present === false) {
        dataLevelPermission = false;
      }else if (
        this.compareKey === 'count_of_versions' &&
        (!('status' in this.elementValue) || (this.elementValue.status?.toLowerCase() !== 'published'))
      ) {
        dataLevelPermission = true;
      }else {
        switch (this.conditionalOperator) {
          case '>':
            dataLevelPermission = !(numLeft > numRight);
            break;
          case '>=':
            dataLevelPermission = !(numLeft >= numRight);
            break;
          case '<':
            dataLevelPermission = !(numLeft < numRight);
            break;
          case '<=':
            dataLevelPermission = !(numLeft <= numRight);
            break;
          case 'equal':
            dataLevelPermission = numLeft != numRight; // invert for disabling
            break;
          case 'not':
            dataLevelPermission = numLeft == numRight;
            break;
          case 'in':
            dataLevelPermission = !Array.isArray(this.conditionalValue) || !this.conditionalValue.includes(String(numLeft));
            break;
          default:
            dataLevelPermission = false;
        }
      }
    } else if( this.elementValue && this.additionalRowPermission){
      const data = get(this.elementValue,this.additionalRowPermission,null);
      dataLevelPermission = !!data ?  true : false ;
      switch (this.conditionalOperator) {
        case 'not':
          dataLevelPermission = !dataLevelPermission; 
          break;
        case 'equal':
          dataLevelPermission = data == this.conditionalValue ? true : false;
          break;
        case 'in':
          dataLevelPermission = Array.isArray(this.conditionalValue) && this.conditionalValue.includes(String(data));
          break;
        case '':
          dataLevelPermission = data;
          break;
        default:
          dataLevelPermission = true;
          break;
      }
    } else {
      dataLevelPermission = true;
    }
    const isDisabled = !(hasPermission && dataLevelPermission);
    this.elementRef.nativeElement.disabled = isDisabled;
    if(!hasPermission) {
      this.renderer.addClass(this.elementRef.nativeElement, 'disabled');
    }else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'disabled');
    }
    this.isDenied = isDisabled;
  }
}